import { Tooltip } from "antd";
import React from "react";
import { IconChevronDown, IconChevronUp } from "../Layout/Icons";

export default function ButtonRoundedSort({ active, setActive }) {
  return (
    <Tooltip
      placement="top"
      title={
        active == "asc"
          ? "Ascending"
          : active == "desc"
          ? "Descending"
          : "Default"
      }
    >
      <div
        className=" p-1 d-flex align-items-center justify-content-center flex-column cursor-pointer"
        onClick={() => {
          if (!active) return setActive("asc");
          if (active == "asc") return setActive("desc");
          return setActive("");
        }}
      >
        <IconChevronUp fill={"asc" == active ? "#838383" : "#BFBFBF"} />
        <IconChevronDown fill={"desc" == active ? "#838383" : "#BFBFBF"} />
      </div>
    </Tooltip>
  );
}
